import brower from 'src/helper/brower'

export const compareVersion = function (v1, v2) {
  // console.log(v1, v2)
  //v1大于等于v2时=1
  //v1小于v2时=0
  if (v1 == v2) {
    return 1
  }

  const vs1 = v1.split('.').map((a) => parseInt(a))
  const vs2 = v2.split('.').map((a) => parseInt(a))

  const length = Math.min(vs1.length, vs2.length)
  for (let i = 0; i < length; i++) {
    if (vs1[i] > vs2[i]) {
      return 1
    } else if (vs1[i] < vs2[i]) {
      return -1
    }
  }

  if (length == vs1.length) {
    return -1
  } else {
    return 1
  }
}


// WEBPACK FOOTER //
// src/helper/domain.js